var _defs, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g, _rect, _path10, _rect2, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetective(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.3 79.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".detective-1{fill:#f7b217;}.detective-2{fill:#ffdc67;}.detective-3{fill:#937237;}.detective-4{fill:#f6f5f5;}.detective-5{fill:#664e27;}.detective-6{fill:#221e1f;}.detective-7{fill:#eca351;}.detective-8{isolation:isolate;opacity:0.4;}.detective-9{fill:#b0bdc6;}.detective-10{fill:#333;}.detective-11{fill:#62727a;}.detective-12{fill:#2c3033;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "detective-1",
    d: "M12.5,51.81h55c0-29.61-4.23-35.95-27.49-35.95S12.5,22.2,12.5,51.81Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "detective-2",
    d: "M65.16,45.35a9.78,9.78,0,0,1-.74,2.83,4.84,4.84,0,0,1-1.8,1.72,31.68,31.68,0,0,0,.21-5.32C61.58,26.26,60.49,31.3,40,31.3S8,34.85,8,47.19c0,9,8.51,13.07,8.51,13.07,2.12,8.85,8.15,13.79,17.67,18.07,2.88,1.29,8.77,1.29,11.65,0C56.35,73.59,62.62,68,64,57.29c4.3-.3,5.57-3.11,5.57-6.53C69.6,45.26,67.1,44.85,65.16,45.35Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "detective-3",
    d: "M49.51,65.4c0,3.63-4.76,5.44-9.52,5.44S30.48,69,30.48,65.4a.9.9,0,0,1,.95-.9H48.56A.9.9,0,0,1,49.51,65.4Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "detective-4",
    d: "M52.68,44c5.29,0,7.4,1.91,7.4,3.81s0,4.65-7,4.65c-6.75,0-7.81-.83-7.81-3.69C45.28,46.81,47.39,44,52.68,44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "detective-5",
    cx: 52.15,
    cy: 47.19,
    r: 4.76
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "detective-6",
    d: "M50.57,47.19a1.59,1.59,0,1,0,1.58-1.59A1.59,1.59,0,0,0,50.57,47.19Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "detective-5",
    d: "M60.08,47.72c0-7.4-14.8-7.4-14.8,1.06C47.39,42.43,58,42.43,60.08,47.72Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "detective-7",
    d: "M40,61.32c-4.42,0-6.63-3.17-4.42-3.17h8.84C46.62,58.15,44.41,61.32,40,61.32Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "detective-4",
    d: "M23.13,42.6c-6.14,0-8.59,2.21-8.59,4.43s0,5.39,8.11,5.39c7.84,0,9.07-1,9.07-4.29C31.72,45.92,29.27,42.6,23.13,42.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "detective-5",
    d: "M23.74,40.83a5.53,5.53,0,1,1-5.52,5.53A5.54,5.54,0,0,1,23.74,40.83Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "detective-6",
    d: "M25.58,46.36a1.84,1.84,0,1,1-1.84-1.84A1.84,1.84,0,0,1,25.58,46.36Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "detective-5",
    d: "M14.54,47c0-8.59,17.18-8.59,17.18,1.23C29.27,40.84,17,40.84,14.54,47Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "detective-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "detective-4",
    cx: 22.9,
    cy: 46.71,
    r: 14.65
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "detective-9",
    x: 12.9,
    y: 59.62,
    width: 2.89,
    height: 3.77,
    transform: "translate(-46.09 43.18) rotate(-60)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "detective-9",
    d: "M11.31,40a13.38,13.38,0,1,1,4.9,18.28A13.38,13.38,0,0,1,11.31,40ZM14.76,60.8a16.28,16.28,0,1,0-6-22.23A16.28,16.28,0,0,0,14.76,60.8Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "detective-10",
    x: 3.62,
    y: 64.8,
    width: 13.68,
    height: 6.9,
    transform: "translate(-53.87 43.17) rotate(-59.99)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "detective-9",
    d: "M3,72.25c-.57,1,7.14,5.44,7.71,4.45l.35-.6c.57-1-7.14-5.44-7.71-4.45Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "detective-11",
    d: "M67.23,26.83c-12-13.39.1-31.47-9.24-25.74A35.31,35.31,0,0,1,39.65,6.37,35.28,35.28,0,0,1,21.31,1.09C12-4.64,24.08,13.43,12.07,26.83.58,33.59,0,32.73,0,34.4c0,.91.48,9,39.65,9s39.65-8.13,39.65-9C79.3,32.73,78.72,33.59,67.23,26.83Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "detective-12",
    d: "M39.65,29.21a203.8,203.8,0,0,0,27.58-2.42,19.93,19.93,0,0,1-3-4.53A177,177,0,0,1,39.65,23.7,178.52,178.52,0,0,1,15.1,22.26a20.26,20.26,0,0,1-3,4.53A203.6,203.6,0,0,0,39.65,29.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetective);
export default __webpack_public_path__ + "static/media/detective.c10ba5b5400a016978fc65cea25630b9.svg";
export { ForwardRef as ReactComponent };